import type { IProductColorInsight, IProductColorInsightResponse } from "types/insights/product-color-insight";

export class ColorInsights implements IProductColorInsight {
    constructor(colorInsight: IProductColorInsightResponse) {
        this.name = colorInsight.color;
        this.rank = colorInsight.rank;
        this.percentage = colorInsight.percentage.this_year;
    }

    name: string;
    rank: number;
    percentage: number;
}
